import React from 'react'

import { Section, SectionLabel } from '../styled'
import Properties from '../Properties'
import CollectionSection from '../CollectionSection'
import PropertySection from '../PropertySection'

export default class View extends React.PureComponent {
  componentDidMount() {
    const { contactObject, related, doFetchRelatedObjects } = this.props
    if (!related) doFetchRelatedObjects(contactObject)
  }
  render() {
    const {
      contactObject,
      credentials,
      tasks,
      opportunities,
      account,
      settings,
    } = this.props

    if (!contactObject) return null
    if (!contactObject.properties) return null
    if (!credentials) return null
    const id = contactObject.id
    const url = [credentials.storeDomain, id].join('/')

    return (
      <React.Fragment>
        {contactObject &&
          contactObject.state === 'fetched' && (
            <React.Fragment>
              <Section>
                <SectionLabel size="small" as="div">
                  {contactObject.type}
                </SectionLabel>
                <Properties
                  properties={contactObject.properties}
                  settings={settings}
                  specificFieldsPattern="showSidebarField.Contact\."
                />
                <a href={url} rel="noopener noreferrer" target="_blank">
                  View {contactObject.type.toLowerCase()} in Salesforce
                </a>
              </Section>
              {account && (
                <PropertySection
                  properties={account.properties}
                  settings={settings}
                  specificFieldsPattern="showSidebarField.Account\."
                  label="Account"
                />
              )}
              {opportunities &&
                opportunities.length > 0 && (
                  <CollectionSection
                    objects={opportunities}
                    settings={settings}
                    specificFieldsPattern="showSidebarField.Opportunity\."
                    label="Opportunities"
                  />
                )}
              {tasks &&
                tasks.length > 0 && (
                  <CollectionSection
                    objects={tasks}
                    settings={settings}
                    specificFieldsPattern="showSidebarField.Task\."
                    label="Tasks"
                  />
                )}
            </React.Fragment>
          )}
      </React.Fragment>
    )
  }
}
